import ViewportObserverService from "Services/ViewportObserverService";
import { IN_VP_EVENT } from "Constants/eventNames";
import { LOADED } from "Constants/cssClasses";

class ZhiImage extends HTMLElement {

  _image = undefined;

  connectedCallback() {
    ViewportObserverService.observe(this);

    this.addEventListener(IN_VP_EVENT, () => this.loadImage());
  }

  get image() {
    if (this._image === undefined) {
      const image = document.createElement("img");
      image.classList.add("zhi-image__image");
      this._image = image;
    }
    return this._image
  }

  get src() {
    return this.getAttribute("src") || "";
  }

  get srcset() {
    return this.getAttribute("srcset") || "";
  }

  get sizes() {
    return this.getAttribute("sizes") || "";
  }

  static get observedAttributes() {
    return ['src', "srcset"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    this.loadImage();
  }

  loadImage() {
    ViewportObserverService.unobserve(this);
    const image = this.image;
    image.setAttribute("src", this.src);
    image.setAttribute("srcset", this.srcset);
    image.setAttribute("sizes", this.sizes);
    image.addEventListener("load", () => this.handleImageLoad(), { once: true });
    this.appendChild(image);
  }

  handleImageLoad() {
    this.classList.add(LOADED);
  }
}

customElements.define("zhi-image", ZhiImage);